import { LocationSurcharge } from "./location-surcharge/location-surcharge.type";
import { CrudAbstractModel } from "../crud-abstract/crud-abstract.model";
import { countryCodes } from "../shared/countries/country-codes.const";
import { LocationAlias } from "./location-alias/location-alias.model";
import { regions } from "app/shared/regions/regions.const";

export class Location extends CrudAbstractModel {
  constructor(
    public id: number,
    private name: string,
    private kind: string,
    private surcharges?: LocationSurcharge[],
    private code?: string,
    private rkstCode?: string,
    private ecuCode?: string,
    private cmaCode?: string,
    private country?: string,
    private region?: string,
    private latitude?: number,
    private longitude?: number,
    public availableOnline?: string,
    public selectedSurcharges: LocationSurcharge[] = [],
    public aliases: LocationAlias[] = [],
    public active: boolean = true,
    public termsTranslations: string[] = [],
  ) {
    super(id);
  }

  public getId(): number {
    return this.id;
  }

  public getName(): string {
    return this.name;
  }

  public getKind(): string {
    return this.kind;
  }

  public getSurcharges(): LocationSurcharge[] {
    return this.surcharges;
  }

  public setSurcharges(charges: LocationSurcharge[]): void {
    this.surcharges = charges;
  }

  public addSurcharge(surcharge: LocationSurcharge) {
    this.surcharges.push(surcharge);
  }

  public getCode(): string {
    return this.code;
  }

  public setCode(c: string) {
    this.code = c;
  }

  public getRkstCode(): string {
    return this.rkstCode;
  }

  public setRkstCode(c: string) {
    this.rkstCode = c;
  }

  public getEcuCode(): string {
    return this.ecuCode;
  }

  public setEcuCode(c: string) {
    this.ecuCode = c;
  }

  public getCmaCode(): string {
    return this.cmaCode;
  }

  public setCmaCode(c: string) {
    this.cmaCode = c;
  }

  public getCountry(): string {
    return this.country;
  }

  public setCountry(c: string) {
    this.country = c;
  }

  public get regionName(): string {
    return regions[this.region];
  }

  public getRegion(): string {
    return this.region;
  }

  public setRegion(r: string) {
    this.region = r;
  }

  public getLatitude(): number {
    return this.latitude;
  }

  public setLatitude(param: number) {
    this.latitude = param;
  }

  public getLongitude(): number {
    return this.longitude;
  }

  public setLongitude(param: number) {
    this.longitude = param;
  }

  public get countryName() {
    return countryCodes[this.country];
  }

  public get surchargeNames() {
    let output = "";
    for (let i = 0; i < this.surcharges.length; i++) {
      output += this.surcharges[i].name;
      if (i < this.surcharges.length - 1) {
        output += ", ";
      }
    }

    return output;
  }

  public get termsTranslationsString(): string {
    return this.termsTranslations ? this.termsTranslations.join(", ") : "";
  }

  public get aliasNames() {
    let output = "";
    for (let i = 0; i < this.aliases.length; i++) {
      output += this.aliases[i].name;
      if (i < this.aliases.length - 1) {
        output += ", ";
      }
    }

    return output;
  }

  public getRequestParams() {
    return {
      name: this.getName(),
      kind: this.getKind(),
      code: this.getCode(),
      rkstCode: this.getRkstCode(),
      ecuCode: this.getEcuCode(),
      cmaCode: this.getCmaCode(),
      region: this.getRegion(),
      country: this.getCountry(),
      latitude: this.getLatitude(),
      longitude: this.getLongitude(),
      availableOnline: this.availableOnline,
    };
  }
}
